export const checkPrice = (rule, value, callback) => {
  if (value > 0) {
    return callback();
  }
  callback('Price must greater than zero');
};
